import API from "../api/v2";

export const callInvitationAPI = async (inviteId, isPreview) => {
  try {
    const response = await API.getInvitation(inviteId, isPreview);
    return response;
  } catch (error) {
    console.log("Get invitation API error | ", error);
    return {};
  }
};

export const addReview = async (body) => {
  try {
    const response = await API.postRequest(`/add/review`, body);
    return response;
  } catch (error) {
    console.log("Get invitation API error | ", error);
    return false;
  }
};

export const addRSVP = async (body) => {
  try {
    const response = await API.postRequest(`/add/rsvp`, body);
    return response;
  } catch (error) {
    console.log("Add RSVP API error | ", error);
    return false;
  }
};
